import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M11.178.091a.75.75 0 0 1 .594.878l-.513 2.67h1.913a.75.75 0 1 1 0 1.5h-2.201l-.716 3.722h2.917a.75.75 0 1 1 0 1.5H9.967l-.568 2.953a.75.75 0 0 1-1.473-.283l.514-2.67H4.743l-.568 2.953a.75.75 0 0 1-1.473-.283l.514-2.67H.827a.75.75 0 0 1 0-1.5h2.677L4.22 5.14H.827a.75.75 0 0 1 0-1.5H4.51L5.076.686A.75.75 0 1 1 6.55.969l-.513 2.67h3.696L10.3.686a.75.75 0 0 1 .879-.595m-5.43 5.048L5.032 8.86h3.695l.716-3.722z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const mailSignHashtag = { render };
export {
  mailSignHashtag as default,
  render
};
//# sourceMappingURL=mail-sign-hashtag.svg.js.map
